// extracted by mini-css-extract-plugin
export default {"additional-info":"AdditionalInfo_additional-info__lqH4-","options":"AdditionalInfo_options__GPwa3","option":"AdditionalInfo_option__uDKY0"};